import {ExternalLinkIcon} from "@chakra-ui/icons";
import React from "react";

export const IconLink = ({url, boxSize}: {url: string, boxSize?: number | undefined}) => {
  return <a href={url} target={"_blank"} rel="noreferrer">
    <ExternalLinkIcon boxSize={boxSize ?? 4} color={"gray.500"} mb={0.5}/>
  </a>
}